import type { Task } from '../model/schema'

/** Порядок списка дел: со временем — по началу, без времени — следом. */
export function compareByTime(a: Task, b: Task): number {
  if (!a.slot) return b.slot ? 1 : 0
  if (!b.slot) return -1
  return a.slot.startsAt.getTime() - b.slot.startsAt.getTime()
}
